module.exports = __webpack_public_path__ + "sq7-a88e9d98.png";